<a (click)="onLinkClick($event)" [routerLink]="[link]" [innerHTML]="content"></a>
